import { alpha } from '@mui/material/styles';

export function buildCardInfoPalette({ mode, brandMain, palette }) {
  const baseBg = mode === 'dark' ? palette.background.paper : '#ffffff';
  const elevatedBg = mode === 'dark' ? baseBg : '#ffffff';
  const titleColor = mode === 'dark' ? '#fdf9f9' : brandMain;
  const subtitleColor = mode === 'dark'
    ? alpha('#ffffff', 0.75)
    : alpha('#000000', 0.65);

  return {
    bg: elevatedBg,
    border: mode === 'dark' ? alpha('#ffffff', 0.12) : alpha('#000000', 0.08),
    shadow: mode === 'dark'
      ? '0 18px 45px rgba(0,0,0,0.5)'
      : '0 12px 30px rgba(0,0,0,0.08)',
    hoverShadow: mode === 'dark'
      ? '0 22px 55px rgba(0,0,0,0.65)'
      : '0 16px 40px rgba(128,0,0,0.25)',
    title: titleColor,
    subtitle: subtitleColor,
    content: palette.text.primary,
    headerBg: mode === 'dark'
      ? alpha(brandMain, 0.35)
      : alpha(brandMain, 0.08),
    headerBorder: mode === 'dark'
      ? alpha('#ffffff', 0.2)
      : alpha(brandMain, 0.2),
  };
}
